import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import TestQuestion from '../components/test/TestQuestion';
import TestLayout from '../components/test/TestLayout';
import TestControls from '../components/test/TestControls';
import ConfirmAbandonModal from '../components/test/ConfirmAbandonModal';
import ExplanationBox from '../components/test/ExplanationBox';
import useTestLogic from '../hooks/useTestLogic';

/**
 * TestPractica component - Practice test mode with explanations and navigation
 */
const TestPractica = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'viajeros';
  
  // Use the shared test logic hook with practice mode settings
  const {
    preguntas,
    preguntaActual,
    respuestas,
    testCompletado,
    cargando,
    error,
    mostrarExplicacion,
    testStatus,
    showConfirmModal,
    resultado,
    preguntaActualObj,
    respuestaActual,
    hasNextQuestion,
    isLastQuestion,
    setShowConfirmModal,
    handleRespuesta,
    handlePreviousQuestion,
    handleNextQuestion,
    handleSaltar,
    handleFinalizarTest,
    handleConfirmAbandon
  } = useTestLogic({
    type,
    isPracticeMode: true,
    questionCount: 30,
    correctAnswerDelay: 500,
    incorrectAnswerDelay: 5000
  });

  // Common letters for answer options
  const letras = ['A', 'B', 'C', 'D'];

  // Check if there are no questions to display
  const noQuestionsFound = !preguntas.length || !preguntaActualObj;

  return (
    <>
      <TestLayout
        title={`TEST PRACTICA ${type === 'viajeros' ? 'VIAJEROS' : 'MERCANCÍAS'}`}
        type={type}
        testStatus={testStatus}
        cargando={cargando}
        error={error}
        testCompletado={testCompletado}
        resultado={resultado}
        noQuestionsFound={noQuestionsFound}
        preguntaActual={preguntaActual}
        totalQuestions={30}
        hasExplanation={mostrarExplicacion}
        isLastQuestion={isLastQuestion}
      >
        {/* Only render if we have questions */}
        {preguntaActualObj && (
          <>
            <TestQuestion
              pregunta={preguntaActualObj.pregunta}
              opciones={preguntaActualObj.opciones}
              letras={letras}
              respuestaActual={respuestaActual}
              respuestaCorrecta={preguntaActualObj.respuestaCorrecta}
              onRespuesta={handleRespuesta}
              mostrarFeedback={!!respuestaActual}
              disabled={!!respuestaActual}
              onPrevious={handlePreviousQuestion}
              onNext={handleNextQuestion}
              currentQuestion={preguntaActual}
              totalQuestions={preguntas.length}
              hasNextQuestion={hasNextQuestion}
              isPracticeMode={true}
            />

            {/* Show explanation if available */}
            {mostrarExplicacion && (
              <ExplanationBox explanation={preguntaActualObj.explicacion} />
            )}
            
            <TestControls
              onSaltar={handleSaltar}
              onFinalizar={handleFinalizarTest}
              isLastQuestion={isLastQuestion}
            />
          </>
        )}
      </TestLayout>
      
      {/* Confirmation modal for back navigation */}
      <ConfirmAbandonModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmAbandon}
      />
    </>
  );
};

const WrappedTestPractica = () => (
  <ProtectedRoute>
    <TestPractica />
  </ProtectedRoute>
);

export default WrappedTestPractica;
